import { render, staticRenderFns } from "./PropertyItemList.vue?vue&type=template&id=771c3426"
import script from "./PropertyItemList.vue?vue&type=script&lang=js"
export * from "./PropertyItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports